import dayjs from "dayjs";

export const mainCategoryMapping: Record<number, string> = {
  188: "EV",
  205: "EV",
  187: "EV",
  204: "EV",
  186: "Hybrid",
  185: "Hybrid",
  226: "EV Swappable",
};

export const formatDate = (date: string | null) => {
  if (!date) return "N/A";
  const parsed = dayjs(date);
  return parsed.isValid() ? parsed.format("DD-MM-YYYY") : "N/A";
};
